<template>
  <div ref="total" class="layout" id="layoutMain" v-bind:class="{ 'layout-fixed': isFixedSize }">
    <!-- 上 -->
    <div ref="north" class="north region" v-if="hasNorth">
      <div class="body" :style="{height: northHeight}">
        <slot v-if="$slots.north" class="north-content" name="north"></slot>
        <!-- 屏幕分割线 -->
        <div v-if="$slots.north"  class="north-split-line" @mousedown="resizeNorthScreen($event)"></div>
      </div>
    </div>

    <!-- 中 -->
    <div class="center-container" :style="{height: centerHeight}">
      <!-- 左 -->
      <div class="west region" v-if="hasWest">
        <div class="body"  :style="{width: westWidth}">
          <slot v-if="$slots.west" name="west"></slot>
        </div>
        <!-- 屏幕分割线 -->
        <div v-if="$slots.west"  class="west-split-line" @mousedown="resizeWestScreen($event)"></div>
        <div v-if="$slots.west && layoutConfigure.expandWest" class="aside_open_close" @click="hasWestWidth" @mousedown="resizeScreenByAside($event)">
          <i class="el-icon-arrow-left" v-if="!isExpandWestWidth"></i>
          <i class="el-icon-arrow-right" v-else></i>
        </div>
      </div>

      <!--  中 -->
      <div class="center region in-panel-remove-right-border" :style="{width: centerWidth}">
        <slot name="center"></slot>
        <div v-if="layoutConfigure.expandCenter" class="aside_open_close" @click="hasCenterWidth">
          <i class="el-icon-arrow-left" v-if="!isExpandCenterWidth"></i>
          <i class="el-icon-arrow-right" v-else></i>
        </div>
      </div>

      <!-- 右 -->
      <div class="east region" v-if="hasEast">
        <div class="body"  :style="{width: eastWidth}">
          <slot v-if="$slots.east" name="east"></slot>
        </div>
        <!-- 屏幕分割线 -->
        <div v-if="$slots.east"  class="east-split-line" @mousedown="resizeEastScreen($event)"></div>
      </div>

    </div>

    <!-- 下 -->
    <div ref="south" class="south region" v-if="hasSouth">
      <div class="body" :style="{height: southHeight}">
        <!-- 屏幕分割线 -->
        <div v-if="$slots.south" class="south-split-line" @mousedown="resizeSouthScreen($event)"></div>
        <slot v-if="$slots.south" name="south"></slot>
      </div>
    </div>


    <slot name="slot1"></slot>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
import {mapGetters} from "vuex";

export default {
  name: "index",
  props: {
    layoutConfigure: {
      type: Object,
      default: {
        northHeight: '',
        southHeight: '',
        westWidth: '',
        eastWidth: '',
        key: '',
        expandWest: { // 是否开启展开西且收缩中的按钮
          type: Boolean,
          default: false,
        },
        expandCenter: { // 是开启展开中且收缩东的按钮
          type: Boolean,
          default: false,
        },
      },

    }
  },

  data() {
    return {
      isFixedSize: false,     //是否固定

      totalHeightNum: 0,     //总高度【数量】
      northHeightNum: 0,     //北高度【数量】
      southHeightNum: 0,     //南高度【数量】

      totalWithNum: 0,       //总宽度【数量】
      westWidthNum: 0,        //西宽度【数量】
      eastWidthNum: 0,        //东宽度【数量】


      northHeight: 'auto',
      centerHeight: 'auto',
      southHeight: 'auto',

      westWidth: 'auto',
      centerWidth: 'auto',
      eastWidth: 'auto',

      oldWestWidth: 'auto', // 用于记录之前的宽度
      oldCenterWidth: 'auto', // 用于记录之前的宽度
      oldEastWidth: 'auto',   // 用于记录之前的宽度
      isExpandWestWidth: true,  // 用于记录按钮是否为展开
      isExpandCenterWidth: true,  // 用于记录按钮是否为展开
      isExpandEastWidth: true,  // 用于记录按钮是否为展开
      hasNorth: true,            //是否有【北】
      hasCenter: false,           //是否有【中】
      hasEast: false,             //是否有【东】
      hasSouth: false,            //是否有【南】

      southTop: 0,          //南距离顶部的高度
      eastLeft: 0,          //东距离左边的高度

    }
  },
  computed: {
    hasWest() {
      return (this.westWidth === 'auto')?false:true;
    }
  },
  watch: {
    northHeightNum(val, oldVal){
      this.changeHeight();
    },
    southHeightNum(val, oldVal){
      this.changeHeight();
    },
    westWidthNum(val, oldVal){
      this.changeWith();
    },
    eastWidthNum(val, oldVal){
      this.changeWith();
    },
  },
  mounted () {
    if(this.layoutConfigure && !!this.layoutConfigure.isFixedSize){
      this.isFixedSize = true;
    }
    if(this.layoutConfigure.key != null && this.layoutConfigure.key != '' && this.layoutConfigure.key != undefined){
      if(!!localStorage.getItem('#' + this.layoutConfigure.key + '-south-page-layout')){
        this.layoutConfigure.southHeight = localStorage.getItem('#' + this.layoutConfigure.key + '-south-page-layout') + 'px';
      }
      if(!!localStorage.getItem('#' + this.layoutConfigure.key + '-north-page-layout')){
        this.layoutConfigure.northHeight = localStorage.getItem('#' + this.layoutConfigure.key + '-north-page-layout') + 'px';
      }
      if(!!localStorage.getItem('#' + this.layoutConfigure.key + '-west-page-layout')){
        this.layoutConfigure.westWidth = localStorage.getItem('#' + this.layoutConfigure.key + '-west-page-layout') + 'px';
      }
      if(!!localStorage.getItem('#' + this.layoutConfigure.key + '-east-page-layout')){
        this.layoutConfigure.eastWidth = localStorage.getItem('#' + this.layoutConfigure.key + '-east-page-layout') + 'px';
      }
    }



    const _this = this;
    const erd = elementResizeDetectorMaker();
    erd.listenTo(document.getElementById("layoutMain"), element => {
      _this.$nextTick(() => {
        if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
          this.hasNorth = (this.northHeight === 'auto')?false:true
          this.hasCenter = (this.centerWidth === 'auto')?false:true
          this.hasEast = (this.eastWidth === 'auto')?false:true
          this.hasSouth = (this.southHeight === 'auto')?false:true
          return false;
        }

        //监听到事件后执行的业务逻辑
        this.setWidthAndHeight();

        //判断东南西北是否存在
        this.hasNorth = (this.northHeight === 'auto')?false:true
        this.hasCenter = (this.centerWidth === 'auto')?false:true
        this.hasEast = (this.eastWidth === 'auto')?false:true
        this.hasSouth = (this.southHeight === 'auto')?false:true

        console.log('西边的宽度');
        console.log(this.layoutConfigure.westWidth);
        console.log(this.westWidth);

      });
    });

    let screenHeight = document.documentElement.clientHeight
    this.$nextTick(()=>{ // 页面渲染完成后的回调
      this.setWidthAndHeight();
    })
  },
  methods: {
    setWidthAndHeight() {


      let northHeightNum = 0;
      let southHeightNum = 0;
      //计算各自的高度
      let totalHeightNum = this.$refs.total.offsetHeight;

      if(this.layoutConfigure.northHeight){
        if(this.layoutConfigure.northHeight.indexOf('px') != -1){
          northHeightNum = parseFloat(this.layoutConfigure.northHeight.replace('px',''));
        }else if(this.layoutConfigure.northHeight.indexOf('%') != -1){
          northHeightNum = parseFloat(this.layoutConfigure.northHeight.replace('%',''))*(0.01)*totalHeightNum;
        }
      }else{
        northHeightNum = totalHeightNum*(0.4);
      }

      if(this.layoutConfigure.southHeight){
        if(this.layoutConfigure.southHeight.indexOf('px') != -1){
          southHeightNum = parseFloat(this.layoutConfigure.southHeight.replace('px',''));
        }else if(this.layoutConfigure.southHeight.indexOf('%') != -1){
          southHeightNum = parseFloat(this.layoutConfigure.southHeight.replace('%',''))*(0.01)*totalHeightNum;
        }
      }else {
        southHeightNum = totalHeightNum*(0.4);
      }

      if(!this.$slots.north){
        northHeightNum = 0;
      }
      if(!this.$slots.south){
        southHeightNum = 0;
      }
      this.totalHeightNum = totalHeightNum;
      this.northHeightNum = northHeightNum;
      this.southHeightNum = southHeightNum;


      if(this.layoutConfigure.centerHeight){
        let centerHeight = 0;
        if(this.layoutConfigure.centerHeight.indexOf('px') != -1){
          centerHeight = parseFloat(this.layoutConfigure.centerHeight.replace('px',''));
        }else if(this.layoutConfigure.centerHeight.indexOf('%') != -1){
          centerHeight = parseFloat(this.layoutConfigure.centerHeight.replace('%',''))*(0.01)*totalHeightNum;
        }
        this.centerHeight = centerHeight + 'px';
      }else {
        this.centerHeight = (this.totalHeightNum - this.northHeightNum - this.southHeightNum) + 'px';
      }

      let westWidthNum = 0;
      let eastWidthNum = 0;
      //计算各自的宽度
      let totalWithNum = this.$refs.total.offsetWidth;




      if(this.layoutConfigure.westWidth){
        if(this.layoutConfigure.westWidth.indexOf('px') != -1){
          westWidthNum = parseFloat(this.layoutConfigure.westWidth.replace('px',''));
        }else if(this.layoutConfigure.westWidth.indexOf('%') != -1){
          westWidthNum = parseFloat(this.layoutConfigure.westWidth.replace('%',''))*(0.01)*totalWithNum;
        }
      }else{
        westWidthNum = totalWithNum*(0.3);
      }



      if(this.layoutConfigure.eastWidth){
        if(this.layoutConfigure.eastWidth.indexOf('px') != -1){
          eastWidthNum = parseFloat(this.layoutConfigure.eastWidth.replace('px',''));
        }else if(this.layoutConfigure.eastWidth.indexOf('%') != -1){
          eastWidthNum = parseFloat(this.layoutConfigure.eastWidth.replace('%',''))*(0.01)*totalWithNum;
        }
      }else {
        eastWidthNum = totalWithNum*(0.3);
      }

      if(!this.$slots.west){
        westWidthNum = 0;
      }
      if(!this.$slots.east){
        eastWidthNum = 0;
      }
      this.totalWithNum = totalWithNum;
      this.westWidthNum = westWidthNum;
      this.eastWidthNum = eastWidthNum;

      if(this.layoutConfigure.centerWidth){

        let centerWidth = 0;
        if(this.layoutConfigure.centerWidth.indexOf('px') != -1){
          centerWidth = parseFloat(this.layoutConfigure.centerWidth.replace('px',''));
        }else if(this.layoutConfigure.centerWidth.indexOf('%') != -1){
          centerWidth = parseFloat(this.layoutConfigure.centerWidth.replace('%',''))*(0.01)*totalWithNum;
        }
        this.centerWidth = centerWidth;
      }else {
        this.centerWidth = (this.totalWithNum - this.westWidthNum - this.eastWidthNum) + 'px';
      }


      // console.log('centerHeight：' + this.centerHeight);







    },
    //修改高度
    changeHeight(){
      this.northHeight = this.northHeightNum + 'px';
      this.southHeight = this.southHeightNum + 'px';
      if(this.layoutConfigure.centerHeight){
        this.centerHeight = (this.centerHeight) + 'px';
      }else{
        this.centerHeight = (this.totalHeightNum - this.northHeightNum - this.southHeightNum - 1) + 'px';
      }
    },
    //修改宽度
    changeWith(){
      this.westWidth = (this.westWidthNum) + 'px';
      this.eastWidth = (this.eastWidthNum) + 'px';
      if(this.layoutConfigure.centerWidth){
        this.centerWidth = (this.centerWidth) + 'px';
      }else{
        this.centerWidth = (this.totalWithNum - this.westWidthNum - this.eastWidthNum - 10) + 'px';
      }
    },
    //拖动北的滚动条
    resizeNorthScreen(e) {
      if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
        return false;
      }
      let oline = e.target //获取目标元素
        ,y = e.clientY
        ,olineT = oline.offsetTop

      document.onmousemove = (e)=>{
        e = e || event;
        let yy = e.clientY;
        let curTop = olineT + yy - y;
        if(curTop < 0) {
          oline.style.top = 0 + 'px';
        } else if(curTop > this.screenH - 3) {
          oline.style.top = this.screenH - 3 + 'px';
        } else {
          oline.style.top = curTop + 'px';
        }
        this.northHeightNum = oline.offsetTop;
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    //拖动南的滚动条
    resizeSouthScreen(e){
      if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
        return false;
      }
      let oline = e.target; //获取目标元素
      this.southTop = e.clientY;   //给南距离页面顶部的高度设置为全局变量


      document.onmousemove = (e)=>{
        let y = this.southTop; //刚开始距离顶部的高度
        e = e || event;
        let yy = e.clientY;

        let northHeightNum = this.northHeightNum; //北的高度
        let southHeightNum = this.southHeightNum; //南的高度
        let totalHeightNum = this.totalHeightNum; //全部的高度
        let curTop = yy - y; //偏移位置

        if(curTop <= northHeightNum + southHeightNum - totalHeightNum){  //偏移量能容许的最大高度
          curTop = northHeightNum + southHeightNum - totalHeightNum;
        }else if(curTop >= southHeightNum - 3){  //页面的最大高度
          curTop = southHeightNum - 3
        }
        oline.style.top = curTop + 'px';

        let newSouthHeightNum = southHeightNum - curTop;  //新南的高度
        this.southTop = curTop + y; //注意，这句是为了补上边超出的情况
        this.southHeightNum = newSouthHeightNum;  //给南设置新的高度
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    //拖动西的滚动条
    resizeWestScreen(e){
      if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
        return false;
      }
      let oline = e.target //获取目标元素
        ,x = e.clientX
        ,olineL = oline.offsetLeft

      document.onmousemove = (e)=>{
        e = e || event;
        let xx = e.clientX;

        let curLeft = olineL + xx - x;
        if(curLeft < 0) {
          curLeft = 0;
        } else if(curLeft > this.screenW - 3) {
          curLeft = this.screenW - 3;
        }

        oline.style.left = curLeft + 'px';

        this.westWidthNum = curLeft;

      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    //拖动东的滚动条
    resizeEastScreen(e){
      if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
        return false;
      }
      let oline = e.target; //获取目标元素

      this.eastLeft = e.clientX;   //给东距离页面最左边的高度设置为全局变量

      document.onmousemove = (e)=>{

        let x = this.eastLeft; //刚开始距离左边的高度

        e = e || event;
        let xx = e.clientX;

        let westWidthNum = this.westWidthNum; //西的宽度
        let eastWidthNum = this.eastWidthNum; //东的宽度
        let totalWithNum = this.totalWithNum; //全部的宽度

        let curLeft = xx - x;

        if(curLeft <= westWidthNum + eastWidthNum - totalWithNum){  //偏移量能容许的最大高度
          curLeft = westWidthNum + eastWidthNum - totalWithNum;
        }else if(curLeft >= eastWidthNum - 3){  //页面的最大高度
          curLeft = eastWidthNum - 3
        }

        oline.style.left = curLeft + 'px';

        let neweastWidthNum = eastWidthNum - curLeft;  //新南的高度
        this.eastLeft = curLeft + x; //注意，这句是为了补上边超出的情况
        this.eastWidthNum = neweastWidthNum;  //给南设置新的高度


      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    //拖动展开/收缩按钮
    resizeScreenByAside(e){
      if(this.isFixedSize){  //如果固定大小，则不执行下边的这些
        return false;
      }
      // let oline = e.target //获取目标元素

      document.onmousemove = (e)=>{
        e = e || event;

        let curLeft = e.clientX;
        if(curLeft < 0) {
          curLeft = 0;
        } else if(curLeft > this.screenW - 3) {
          curLeft = this.screenW - 3;
        }

        // oline.style.left = curLeft + 'px';

        this.westWidthNum = curLeft;

      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    //展开或收起西部
    hasWestWidth(){
      // 1. 保存之前的设置
      if (this.oldCenterWidth == 'auto'){
        this.oldCenterWidth = this.centerWidth
      }
      if (this.oldWestWidth == 'auto' ){
        this.oldWestWidth = this.westWidth
      }
      if (this.oldEastWidth == 'auto'){
        this.oldEastWidth = this.eastWidth
      }
      //2 获取是展开还是收起
      if (this.isExpandWestWidth){
        // 如果是展开 设置中部宽度为0
        const west = parseInt(this.westWidth);
        const center = parseInt(this.centerWidth)
        this.centerWidth = 0 +'px';
        this.westWidth = west + center + 'px';
      }else{
        // 设置西部宽度回归原始
        this.westWidth = this.oldWestWidth;
        this.centerWidth = this.oldCenterWidth

      }
      this.isExpandWestWidth = !this.isExpandWestWidth
    },
    //展开或收起中部
    hasCenterWidth(){
      // 1. 保存之前的设置
      if (this.oldCenterWidth == 'auto'){
        this.oldCenterWidth = this.centerWidth
      }
      if (this.oldWestWidth == 'auto' ){
        this.oldWestWidth = this.westWidth
      }
      if (this.oldEastWidth == 'auto'){
        this.oldEastWidth = this.eastWidth
      }
      //2 获取是展开还是收起
      if (this.isExpandCenterWidth){
        // 如果是展开 设置东部宽度为0
        const east = parseInt(this.eastWidth);
        const center = parseInt(this.centerWidth)
        this.eastWidth = 0 + 'px';
        this.westWidth = east + center + 'px';
      }else{
        // 设置西部宽度回归原始
        this.eastWidth = this.oldEastWidth;
        this.centerWidth = this.oldCenterWidth

      }
      this.isExpandCenterWidth = !this.isExpandCenterWidth
    },
  }
}
</script>

<style lang="scss" scoped>
.center-container{
  overflow: hidden;
  width: 100%;
}

.body{
  position: relative;
}

.layout {
  position: relative;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  .north{
    width: 100%;
    height: auto;
    .north-split-line{
      position: absolute;
      width: 100%;
      height: 1px;
      border-width: 1px 0;
      border-style: solid;
      border-color: #e6e6e6;
      cursor:row-resize;
      bottom: 0px;
    }
  }
  .south{
    width: 100%;
    height: auto;
    .south-split-line{
      position: absolute;
      width: 100%;
      height: 1px;
      border-width: 1px 0;
      border-style: solid;
      border-color: #e6e6e6;
      cursor:row-resize;
      top: 0px;
    }
  }
  .west{
    width: auto;
    height: 100%;
    position: relative;
    .west-split-line{
      position: absolute;
      width: 3px;
      height: 100%;
      border-width: 0 1px;
      border-style: solid;
      /*border-color: #e6e6e6;*/
      border-color: #fff;
      cursor: col-resize;
      right: 0px;
    }
    .body{
      box-sizing: content-box;
      height: 100%;
      float: left;
    }

  }
  .east{
    width: auto;
    height: 100%;
    position: relative;
    .east-split-line{
      position: absolute;
      width: 3px;
      height: 100%;
      border-width: 0 1px;
      border-style: solid;
      border-color: #FFF;
      cursor: col-resize;
      left: 0px;
    }
    .body{
      box-sizing: content-box;
      height: 100%;
      float: left;
    }
  }
  .center{
    width: auto;
    height: 100%;
  }
}


.west{
  float: left;
}


.center{
  float: left;
  overflow: auto;
}


.east{
  float: left;
}

.layout{overflow-y: auto;}


.aside_open_close{
  position: absolute;
  top: 50%;
  width: 16px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  background-color: rgba(39, 151, 109, 0.95);
  border-radius:  6px 0 0 6px ;
  font-size: 20px;
  z-index: 1000;
  cursor: pointer;
  right: 8px;
  transform: translateY(-50%)
}

.aside_open_close:hover{
  background-color: rgb(41, 151, 109);
  //transform: scale(1.1);
  color: #fff;
}

.layout.layout-fixed .north .north-split-line{display: none;}
.layout.layout-fixed .west .west-split-line{display: none;}




</style>



// WEBPACK FOOTER //
// src/components/XrLayout/index.vue